import { FC } from 'react';
import { twMerge } from 'tailwind-merge';

import { AppFormattedMessage } from '../../../components/app-formatted-message/index';
import { Table } from '../../../components/table/index';
import { useScreenSize } from '../../../hooks/index';
import { useInvestmentHistory } from '../hooks/index';
import { InvestmentItem } from './investment-item';
import { columnOrderMap, columnTranslationKey } from './investment-ledger.types';

type InvestmentLedgerProps = {
  queriesEnabled: boolean;
  stakeholderId: string;
};

export const InvestmentLedger: FC<InvestmentLedgerProps> = ({ queriesEnabled, stakeholderId }) => {
  const { investments } = useInvestmentHistory({ enabled: queriesEnabled, stakeholderId });
  const { isMobile } = useScreenSize();
  if (!investments.length) return;

  return (
    <div className="max flex w-full flex-col gap-3 rounded-lg bg-gray-50 p-1 !pt-3 lg:p-[2px]">
      <span className="pl-4 text-[10px] font-bold uppercase leading-4 tracking-[1px] text-gray-700">
        <AppFormattedMessage id="INVESTMENT_HISTORY" />
      </span>

      <div
        className={twMerge(
          'flex gap-2 overflow-hidden rounded-md shadow-sm',
          !isMobile && 'bg-white px-2 pb-2 pt-1',
        )}
      >
        <div
          className={twMerge(
            'flex h-full w-full flex-col gap-1 overflow-x-auto rounded-md border border-gray-100',
          )}
        >
          {isMobile ? (
            investments.map((data) => <InvestmentItem data={data} key={data.id} />)
          ) : (
            <Table columnOrder={columnOrderMap} columnsTitle={columnTranslationKey}>
              {investments.map((data) => (
                <InvestmentItem data={data} key={data.id} mode="TABLE" />
              ))}
            </Table>
          )}
        </div>
      </div>
    </div>
  );
};
